module.exports = __webpack_public_path__ + "static/media/photo-mountain.c11cb7c7.svg";